import { Route } from '@angular/router';
import {
    authenticatedLayoutInitialDataResolver,
    publicLayoutInitialDataResolver
} from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/home'
    { path: '', pathMatch: 'full', redirectTo: 'home' },

    // Redirect signed-in user to the '/home'
    //
    // After the user signs in, the login page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

    // Backward-compat redirects for old WMS and Logger System shortcuts
    {
        path: 'wms',
        children: [
            { path: '', pathMatch: 'full', redirectTo: '/external/wms' },
            {
                path: 'home',
                pathMatch: 'full',
                redirectTo: '/external/wms/home'
            }
        ]
    },
    {
        path: 'logger-system',
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: '/external/logger-system'
            },
            {
                path: 'home',
                pathMatch: 'full',
                redirectTo: '/external/logger-system/home'
            }
        ]
    },

    {
        path: 'login/coupa',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        loadComponent: () => import('app/layout/layout.component'),
        data: {
            layout: 'empty',
            title: 'Login Coupa'
        },
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('app/modules/auth/login-coupa/login-coupa.routes')
            }
        ]
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        loadComponent: () => import('app/layout/layout.component'),
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: 'forgot-password',
                loadComponent: () =>
                    import(
                        'app/modules/auth/forgot-password/forgot-password.component'
                    ).then(c => c.ForgotPasswordComponent),
                data: { title: 'Forgot password' }
            }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        loadComponent: () => import('app/layout/layout.component'),
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth-fuse/sign-out/sign-out.routes')
            },
            {
                path: 'unlock-session',
                loadChildren: () =>
                    import(
                        'app/modules/auth-fuse/unlock-session/unlock-session.routes'
                    )
            }
        ]
    },

    // Landing routes
    /*{
        path: '',
        loadComponent: () => import('app/layout/layout.component'),
        data: {
            layout: 'empty'
        }
    },*/

    {
        path: '',
        loadComponent: () => import('app/layout/layout.component'),
        resolve: {
            initialData: publicLayoutInitialDataResolver
        },
        children: [
            {
                path: 'home',
                // 👇 ESTE ES EL CAMBIO CLAVE 👇
                loadChildren: () => import('app/modules/home/home.routes'),
                data: { title: 'Home' }
            }
        ]
    },
    // Premiums route - Public access with conditional resolver
    {
        path: '',
        loadComponent: () => import('app/layout/layout.component'),
        resolve: {
            initialData: publicLayoutInitialDataResolver
        },
        children: [
            {
                path: 'premiums',
                loadChildren: () =>
                    import('app/modules/catalogue/premiums/premiums.routes')
            }
        ]
    },

    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        loadComponent: () => import('app/layout/layout.component'),
        resolve: {
            initialData: authenticatedLayoutInitialDataResolver
        },
        children: [
            {
                path: 'notification-center',
                loadChildren: () =>
                    import(
                        'app/modules/notifications-center/notifications-center.routes'
                    )
            },
            {
                path: 'premium-shopping-cart',
                loadChildren: () =>
                    import('app/modules/shopping-cart/premiums/premiums.routes')
            },
            {
                path: 'pop-shopping-cart',
                loadChildren: () =>
                    import('app/modules/shopping-cart/premiums/premiums.routes')
            },
            {
                path: 'pop',
                loadChildren: () =>
                    import('app/modules/catalogue/pop/pop.routes')
            },
            {
                path: 'mercadolibre',
                loadChildren: () =>
                    import(
                        'app/modules/catalogue/mercadolibre/mercadolibre.routes'
                    )
            },
            {
                path: 'premium-orders',
                loadChildren: () =>
                    import('app/modules/orders/premiums/premiums.routes')
            },
            {
                path: 'pop-orders',
                loadChildren: () => import('app/modules/orders/pop/pop.routes')
            },
            {
                path: 'rfq',
                loadChildren: () => import('app/modules/rfq/rfq.routes')
            },
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('app/modules/dashboard/premiums/premium.routes')
                //import('app/modules/dashboard/dashboard.routes')
            },
            {
                path: 'automobiles',
                loadChildren: () =>
                    import('app/modules/automobiles/automobiles.routes')
            },
            // ADMIN ROUTES
            {
                path: 'admin',
                loadChildren: () => import('app/modules/admin/admin.routes')
            },
            {
                path: 'external',
                loadChildren: () =>
                    import('app/modules/external/external.routes')
            }
        ]
    }
];
